/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WinNumberRouteImport } from './routes/win-number'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as OauthCallbackRouteImport } from './routes/oauth-callback'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GetStartedRouteImport } from './routes/get-started'
import { Route as EulaRouteImport } from './routes/eula'
import { Route as EarlyRouteImport } from './routes/early'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CompleteRegistrationRouteImport } from './routes/complete-registration'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SubscribeIndexRouteImport } from './routes/subscribe/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as VoterListTokenRouteImport } from './routes/voter-list/$token'
import { Route as TextStatusTokenRouteImport } from './routes/text-status/$token'
import { Route as SubscribeCompleteRouteImport } from './routes/subscribe/complete'
import { Route as LegalAcceptRouteImport } from './routes/legal.accept'
import { Route as ExpressSendRouteImport } from './routes/express/send'
import { Route as ExpressCodeRouteImport } from './routes/express/$code'
import { Route as EmbedSlugRouteImport } from './routes/embed.$slug'
import { Route as DonateSlugRouteImport } from './routes/donate/$slug'
import { Route as AppVoteGoalRouteImport } from './routes/app/vote-goal'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as AppHomeRouteImport } from './routes/app/home'
import { Route as AppFieldOpsRouteImport } from './routes/app/field-ops'
import { Route as AppAnalyticsRouteImport } from './routes/app/analytics'
import { Route as AdminVoterDataRouteImport } from './routes/admin/voter-data'
import { Route as AdminTagsRouteImport } from './routes/admin/tags'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminResourcesRouteImport } from './routes/admin/resources'
import { Route as AdminFundraisingRouteImport } from './routes/admin/fundraising'
import { Route as AdminFinanceRouteImport } from './routes/admin/finance'
import { Route as AdminElectionOutcomesRouteImport } from './routes/admin/election-outcomes'
import { Route as AdminCampaignSettingsRouteImport } from './routes/admin/campaign-settings'
import { Route as AppWorkOrdersRouteRouteImport } from './routes/app/work-orders/route'
import { Route as AppWorkOrdersIndexRouteImport } from './routes/app/work-orders/index'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppAnalyticsIndexRouteImport } from './routes/app/analytics/index'
import { Route as AdminFundraisingIndexRouteImport } from './routes/admin/fundraising/index'
import { Route as AdminFinanceIndexRouteImport } from './routes/admin/finance/index'
import { Route as AdminAssistantTestIndexRouteImport } from './routes/admin/assistant-test/index'
import { Route as AdminAssistantTelemetryIndexRouteImport } from './routes/admin/assistant-telemetry/index'
import { Route as AppWorkOrdersVoterDataRouteImport } from './routes/app/work-orders/voter-data'
import { Route as AppWorkOrdersWorkOrderIdRouteImport } from './routes/app/work-orders/$workOrderId'
import { Route as AppSettingsPlaybookRouteImport } from './routes/app/settings/playbook'
import { Route as AppSettingsCampaignPreferencesRouteImport } from './routes/app/settings/campaign-preferences'
import { Route as AppSettingsCampaignCommitteeRouteImport } from './routes/app/settings/campaign-committee'
import { Route as AppSettingsBillingRouteImport } from './routes/app/settings/billing'
import { Route as AdminMessagingProfilesRouteImport } from './routes/admin/messaging/profiles'
import { Route as AdminMessagingProfileRouteImport } from './routes/admin/messaging/profile'
import { Route as AdminFundraisingMatchReviewRouteImport } from './routes/admin/fundraising/match-review'
import { Route as AdminFundraisingFollowUpsRouteImport } from './routes/admin/fundraising/follow-ups'
import { Route as AdminFundraisingCommitmentsRouteImport } from './routes/admin/fundraising/commitments'
import { Route as AdminFinanceTransactionsRouteImport } from './routes/admin/finance/transactions'
import { Route as AdminFinanceStagedRouteImport } from './routes/admin/finance/staged'
import { Route as AdminFinanceSourcesRouteImport } from './routes/admin/finance/sources'
import { Route as AdminFinanceSetupRouteImport } from './routes/admin/finance/setup'
import { Route as AdminFinanceSettingsRouteImport } from './routes/admin/finance/settings'
import { Route as AdminFinancePaymentsRouteImport } from './routes/admin/finance/payments'
import { Route as AdminFinanceInboxRouteImport } from './routes/admin/finance/inbox'
import { Route as AdminFinanceFilingsRouteImport } from './routes/admin/finance/filings'
import { Route as AdminFinanceDeadlinesRouteImport } from './routes/admin/finance/deadlines'
import { Route as AdminFinanceCloseRouteImport } from './routes/admin/finance/close'
import { Route as AdminFinanceAuditLogRouteImport } from './routes/admin/finance/audit-log'
import { Route as SubsidiaryDonateSlugRouteImport } from './routes/$subsidiary/donate/$slug'
import { Route as AdminFundraisingProspectsIndexRouteImport } from './routes/admin/fundraising/prospects/index'
import { Route as AdminFundraisingCallBooksIndexRouteImport } from './routes/admin/fundraising/call-books/index'
import { Route as AdminFinanceSettingsIndexRouteImport } from './routes/admin/finance/settings/index'
import { Route as AdminFinanceReportsIndexRouteImport } from './routes/admin/finance/reports/index'
import { Route as AdminFinanceLoansIndexRouteImport } from './routes/admin/finance/loans/index'
import { Route as AdminFinanceExpendituresIndexRouteImport } from './routes/admin/finance/expenditures/index'
import { Route as AdminFinanceDebtsIndexRouteImport } from './routes/admin/finance/debts/index'
import { Route as AdminFinanceContributionsIndexRouteImport } from './routes/admin/finance/contributions/index'
import { Route as AdminFinanceContactsIndexRouteImport } from './routes/admin/finance/contacts/index'
import { Route as AdminFinanceCloseIndexRouteImport } from './routes/admin/finance/close/index'
import { Route as AppAnalyticsVendorsVendorIdRouteImport } from './routes/app/analytics/vendors.$vendorId'
import { Route as AppAnalyticsCanvassersUserIdRouteImport } from './routes/app/analytics/canvassers.$userId'
import { Route as AdminFundraisingProspectsProspectIdRouteImport } from './routes/admin/fundraising/prospects/$prospectId'
import { Route as AdminFundraisingCallBooksSheetIdRouteImport } from './routes/admin/fundraising/call-books/$sheetId'
import { Route as AdminFinanceSettingsSourcesRouteImport } from './routes/admin/finance/settings/sources'
import { Route as AdminFinanceSettingsSetupRouteImport } from './routes/admin/finance/settings/setup'
import { Route as AdminFinanceSettingsRulesRouteImport } from './routes/admin/finance/settings/rules'
import { Route as AdminFinanceSettingsRecurringRouteImport } from './routes/admin/finance/settings/recurring'
import { Route as AdminFinanceSettingsProcessorsRouteImport } from './routes/admin/finance/settings/processors'
import { Route as AdminFinanceSettingsElectionOutcomeRouteImport } from './routes/admin/finance/settings/election-outcome'
import { Route as AdminFinanceSettingsBankAccountsRouteImport } from './routes/admin/finance/settings/bank-accounts'
import { Route as AdminFinanceSettingsAuditLogRouteImport } from './routes/admin/finance/settings/audit-log'
import { Route as AdminFinanceReportsReportIdRouteImport } from './routes/admin/finance/reports/$reportId'
import { Route as AdminFinanceExpendituresExpenditureIdRouteImport } from './routes/admin/finance/expenditures/$expenditureId'
import { Route as AdminFinanceContributionsContributionIdRouteImport } from './routes/admin/finance/contributions/$contributionId'
import { Route as AdminFinanceContactsContactIdRouteImport } from './routes/admin/finance/contacts/$contactId'
import { Route as AdminFinanceCloseFileRouteImport } from './routes/admin/finance/close/file'
import { Route as AdminFinanceBankTransactionsBankTransactionIdRouteImport } from './routes/admin/finance/bank-transactions/$bankTransactionId'
import { Route as AdminAssistantTelemetryRunsRunIdRouteImport } from './routes/admin/assistant-telemetry/runs.$runId'
import { Route as AdminFinanceSettingsContactsIndexRouteImport } from './routes/admin/finance/settings/contacts/index'
import { Route as AppAnalyticsQuestionsQuestionIdAnswersRouteImport } from './routes/app/analytics/questions.$questionId.answers'
import { Route as AdminFinanceSettingsContactsContactIdRouteImport } from './routes/admin/finance/settings/contacts/$contactId'

const WinNumberRoute = WinNumberRouteImport.update({
  id: '/win-number',
  path: '/win-number',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthCallbackRoute = OauthCallbackRouteImport.update({
  id: '/oauth-callback',
  path: '/oauth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GetStartedRoute = GetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRouteImport,
} as any)
const EulaRoute = EulaRouteImport.update({
  id: '/eula',
  path: '/eula',
  getParentRoute: () => rootRouteImport,
} as any)
const EarlyRoute = EarlyRouteImport.update({
  id: '/early',
  path: '/early',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteRegistrationRoute = CompleteRegistrationRouteImport.update({
  id: '/complete-registration',
  path: '/complete-registration',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeIndexRoute = SubscribeIndexRouteImport.update({
  id: '/subscribe/',
  path: '/subscribe/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const VoterListTokenRoute = VoterListTokenRouteImport.update({
  id: '/voter-list/$token',
  path: '/voter-list/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TextStatusTokenRoute = TextStatusTokenRouteImport.update({
  id: '/text-status/$token',
  path: '/text-status/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeCompleteRoute = SubscribeCompleteRouteImport.update({
  id: '/subscribe/complete',
  path: '/subscribe/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalAcceptRoute = LegalAcceptRouteImport.update({
  id: '/legal/accept',
  path: '/legal/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpressSendRoute = ExpressSendRouteImport.update({
  id: '/express/send',
  path: '/express/send',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpressCodeRoute = ExpressCodeRouteImport.update({
  id: '/express/$code',
  path: '/express/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedSlugRoute = EmbedSlugRouteImport.update({
  id: '/embed/$slug',
  path: '/embed/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateSlugRoute = DonateSlugRouteImport.update({
  id: '/donate/$slug',
  path: '/donate/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVoteGoalRoute = AppVoteGoalRouteImport.update({
  id: '/vote-goal',
  path: '/vote-goal',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFieldOpsRoute = AppFieldOpsRouteImport.update({
  id: '/field-ops',
  path: '/field-ops',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminVoterDataRoute = AdminVoterDataRouteImport.update({
  id: '/voter-data',
  path: '/voter-data',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTagsRoute = AdminTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminResourcesRoute = AdminResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFundraisingRoute = AdminFundraisingRouteImport.update({
  id: '/fundraising',
  path: '/fundraising',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFinanceRoute = AdminFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminElectionOutcomesRoute = AdminElectionOutcomesRouteImport.update({
  id: '/election-outcomes',
  path: '/election-outcomes',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCampaignSettingsRoute = AdminCampaignSettingsRouteImport.update({
  id: '/campaign-settings',
  path: '/campaign-settings',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppWorkOrdersRouteRoute = AppWorkOrdersRouteRouteImport.update({
  id: '/work-orders',
  path: '/work-orders',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppWorkOrdersIndexRoute = AppWorkOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkOrdersRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppAnalyticsIndexRoute = AppAnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAnalyticsRoute,
} as any)
const AdminFundraisingIndexRoute = AdminFundraisingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFundraisingRoute,
} as any)
const AdminFinanceIndexRoute = AdminFinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminAssistantTestIndexRoute = AdminAssistantTestIndexRouteImport.update({
  id: '/assistant-test/',
  path: '/assistant-test/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAssistantTelemetryIndexRoute =
  AdminAssistantTelemetryIndexRouteImport.update({
    id: '/assistant-telemetry/',
    path: '/assistant-telemetry/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AppWorkOrdersVoterDataRoute = AppWorkOrdersVoterDataRouteImport.update({
  id: '/voter-data',
  path: '/voter-data',
  getParentRoute: () => AppWorkOrdersRouteRoute,
} as any)
const AppWorkOrdersWorkOrderIdRoute =
  AppWorkOrdersWorkOrderIdRouteImport.update({
    id: '/$workOrderId',
    path: '/$workOrderId',
    getParentRoute: () => AppWorkOrdersRouteRoute,
  } as any)
const AppSettingsPlaybookRoute = AppSettingsPlaybookRouteImport.update({
  id: '/playbook',
  path: '/playbook',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCampaignPreferencesRoute =
  AppSettingsCampaignPreferencesRouteImport.update({
    id: '/campaign-preferences',
    path: '/campaign-preferences',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsCampaignCommitteeRoute =
  AppSettingsCampaignCommitteeRouteImport.update({
    id: '/campaign-committee',
    path: '/campaign-committee',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AdminMessagingProfilesRoute = AdminMessagingProfilesRouteImport.update({
  id: '/messaging/profiles',
  path: '/messaging/profiles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMessagingProfileRoute = AdminMessagingProfileRouteImport.update({
  id: '/messaging/profile',
  path: '/messaging/profile',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFundraisingMatchReviewRoute =
  AdminFundraisingMatchReviewRouteImport.update({
    id: '/match-review',
    path: '/match-review',
    getParentRoute: () => AdminFundraisingRoute,
  } as any)
const AdminFundraisingFollowUpsRoute =
  AdminFundraisingFollowUpsRouteImport.update({
    id: '/follow-ups',
    path: '/follow-ups',
    getParentRoute: () => AdminFundraisingRoute,
  } as any)
const AdminFundraisingCommitmentsRoute =
  AdminFundraisingCommitmentsRouteImport.update({
    id: '/commitments',
    path: '/commitments',
    getParentRoute: () => AdminFundraisingRoute,
  } as any)
const AdminFinanceTransactionsRoute =
  AdminFinanceTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceStagedRoute = AdminFinanceStagedRouteImport.update({
  id: '/staged',
  path: '/staged',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceSourcesRoute = AdminFinanceSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceSetupRoute = AdminFinanceSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceSettingsRoute = AdminFinanceSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinancePaymentsRoute = AdminFinancePaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceInboxRoute = AdminFinanceInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceFilingsRoute = AdminFinanceFilingsRouteImport.update({
  id: '/filings',
  path: '/filings',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceDeadlinesRoute = AdminFinanceDeadlinesRouteImport.update({
  id: '/deadlines',
  path: '/deadlines',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceCloseRoute = AdminFinanceCloseRouteImport.update({
  id: '/close',
  path: '/close',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceAuditLogRoute = AdminFinanceAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const SubsidiaryDonateSlugRoute = SubsidiaryDonateSlugRouteImport.update({
  id: '/$subsidiary/donate/$slug',
  path: '/$subsidiary/donate/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFundraisingProspectsIndexRoute =
  AdminFundraisingProspectsIndexRouteImport.update({
    id: '/prospects/',
    path: '/prospects/',
    getParentRoute: () => AdminFundraisingRoute,
  } as any)
const AdminFundraisingCallBooksIndexRoute =
  AdminFundraisingCallBooksIndexRouteImport.update({
    id: '/call-books/',
    path: '/call-books/',
    getParentRoute: () => AdminFundraisingRoute,
  } as any)
const AdminFinanceSettingsIndexRoute =
  AdminFinanceSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceReportsIndexRoute =
  AdminFinanceReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceLoansIndexRoute = AdminFinanceLoansIndexRouteImport.update({
  id: '/loans/',
  path: '/loans/',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceExpendituresIndexRoute =
  AdminFinanceExpendituresIndexRouteImport.update({
    id: '/expenditures/',
    path: '/expenditures/',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceDebtsIndexRoute = AdminFinanceDebtsIndexRouteImport.update({
  id: '/debts/',
  path: '/debts/',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFinanceContributionsIndexRoute =
  AdminFinanceContributionsIndexRouteImport.update({
    id: '/contributions/',
    path: '/contributions/',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceContactsIndexRoute =
  AdminFinanceContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceCloseIndexRoute = AdminFinanceCloseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFinanceCloseRoute,
} as any)
const AppAnalyticsVendorsVendorIdRoute =
  AppAnalyticsVendorsVendorIdRouteImport.update({
    id: '/vendors/$vendorId',
    path: '/vendors/$vendorId',
    getParentRoute: () => AppAnalyticsRoute,
  } as any)
const AppAnalyticsCanvassersUserIdRoute =
  AppAnalyticsCanvassersUserIdRouteImport.update({
    id: '/canvassers/$userId',
    path: '/canvassers/$userId',
    getParentRoute: () => AppAnalyticsRoute,
  } as any)
const AdminFundraisingProspectsProspectIdRoute =
  AdminFundraisingProspectsProspectIdRouteImport.update({
    id: '/prospects/$prospectId',
    path: '/prospects/$prospectId',
    getParentRoute: () => AdminFundraisingRoute,
  } as any)
const AdminFundraisingCallBooksSheetIdRoute =
  AdminFundraisingCallBooksSheetIdRouteImport.update({
    id: '/call-books/$sheetId',
    path: '/call-books/$sheetId',
    getParentRoute: () => AdminFundraisingRoute,
  } as any)
const AdminFinanceSettingsSourcesRoute =
  AdminFinanceSettingsSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceSettingsSetupRoute =
  AdminFinanceSettingsSetupRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceSettingsRulesRoute =
  AdminFinanceSettingsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceSettingsRecurringRoute =
  AdminFinanceSettingsRecurringRouteImport.update({
    id: '/recurring',
    path: '/recurring',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceSettingsProcessorsRoute =
  AdminFinanceSettingsProcessorsRouteImport.update({
    id: '/processors',
    path: '/processors',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceSettingsElectionOutcomeRoute =
  AdminFinanceSettingsElectionOutcomeRouteImport.update({
    id: '/election-outcome',
    path: '/election-outcome',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceSettingsBankAccountsRoute =
  AdminFinanceSettingsBankAccountsRouteImport.update({
    id: '/bank-accounts',
    path: '/bank-accounts',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceSettingsAuditLogRoute =
  AdminFinanceSettingsAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AdminFinanceReportsReportIdRoute =
  AdminFinanceReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceExpendituresExpenditureIdRoute =
  AdminFinanceExpendituresExpenditureIdRouteImport.update({
    id: '/expenditures/$expenditureId',
    path: '/expenditures/$expenditureId',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceContributionsContributionIdRoute =
  AdminFinanceContributionsContributionIdRouteImport.update({
    id: '/contributions/$contributionId',
    path: '/contributions/$contributionId',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceContactsContactIdRoute =
  AdminFinanceContactsContactIdRouteImport.update({
    id: '/contacts/$contactId',
    path: '/contacts/$contactId',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceCloseFileRoute = AdminFinanceCloseFileRouteImport.update({
  id: '/file',
  path: '/file',
  getParentRoute: () => AdminFinanceCloseRoute,
} as any)
const AdminFinanceBankTransactionsBankTransactionIdRoute =
  AdminFinanceBankTransactionsBankTransactionIdRouteImport.update({
    id: '/bank-transactions/$bankTransactionId',
    path: '/bank-transactions/$bankTransactionId',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminAssistantTelemetryRunsRunIdRoute =
  AdminAssistantTelemetryRunsRunIdRouteImport.update({
    id: '/assistant-telemetry/runs/$runId',
    path: '/assistant-telemetry/runs/$runId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminFinanceSettingsContactsIndexRoute =
  AdminFinanceSettingsContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)
const AppAnalyticsQuestionsQuestionIdAnswersRoute =
  AppAnalyticsQuestionsQuestionIdAnswersRouteImport.update({
    id: '/questions/$questionId/answers',
    path: '/questions/$questionId/answers',
    getParentRoute: () => AppAnalyticsRoute,
  } as any)
const AdminFinanceSettingsContactsContactIdRoute =
  AdminFinanceSettingsContactsContactIdRouteImport.update({
    id: '/contacts/$contactId',
    path: '/contacts/$contactId',
    getParentRoute: () => AdminFinanceSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/complete-registration': typeof CompleteRegistrationRoute
  '/dashboard': typeof DashboardRoute
  '/early': typeof EarlyRoute
  '/eula': typeof EulaRoute
  '/get-started': typeof GetStartedRoute
  '/login': typeof LoginRoute
  '/oauth-callback': typeof OauthCallbackRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/win-number': typeof WinNumberRoute
  '/app/work-orders': typeof AppWorkOrdersRouteRouteWithChildren
  '/admin/campaign-settings': typeof AdminCampaignSettingsRoute
  '/admin/election-outcomes': typeof AdminElectionOutcomesRoute
  '/admin/finance': typeof AdminFinanceRouteWithChildren
  '/admin/fundraising': typeof AdminFundraisingRouteWithChildren
  '/admin/resources': typeof AdminResourcesRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/voter-data': typeof AdminVoterDataRoute
  '/app/analytics': typeof AppAnalyticsRouteWithChildren
  '/app/field-ops': typeof AppFieldOpsRoute
  '/app/home': typeof AppHomeRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/vote-goal': typeof AppVoteGoalRoute
  '/donate/$slug': typeof DonateSlugRoute
  '/embed/$slug': typeof EmbedSlugRoute
  '/express/$code': typeof ExpressCodeRoute
  '/express/send': typeof ExpressSendRoute
  '/legal/accept': typeof LegalAcceptRoute
  '/subscribe/complete': typeof SubscribeCompleteRoute
  '/text-status/$token': typeof TextStatusTokenRoute
  '/voter-list/$token': typeof VoterListTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/subscribe': typeof SubscribeIndexRoute
  '/$subsidiary/donate/$slug': typeof SubsidiaryDonateSlugRoute
  '/admin/finance/audit-log': typeof AdminFinanceAuditLogRoute
  '/admin/finance/close': typeof AdminFinanceCloseRouteWithChildren
  '/admin/finance/deadlines': typeof AdminFinanceDeadlinesRoute
  '/admin/finance/filings': typeof AdminFinanceFilingsRoute
  '/admin/finance/inbox': typeof AdminFinanceInboxRoute
  '/admin/finance/payments': typeof AdminFinancePaymentsRoute
  '/admin/finance/settings': typeof AdminFinanceSettingsRouteWithChildren
  '/admin/finance/setup': typeof AdminFinanceSetupRoute
  '/admin/finance/sources': typeof AdminFinanceSourcesRoute
  '/admin/finance/staged': typeof AdminFinanceStagedRoute
  '/admin/finance/transactions': typeof AdminFinanceTransactionsRoute
  '/admin/fundraising/commitments': typeof AdminFundraisingCommitmentsRoute
  '/admin/fundraising/follow-ups': typeof AdminFundraisingFollowUpsRoute
  '/admin/fundraising/match-review': typeof AdminFundraisingMatchReviewRoute
  '/admin/messaging/profile': typeof AdminMessagingProfileRoute
  '/admin/messaging/profiles': typeof AdminMessagingProfilesRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/settings/campaign-committee': typeof AppSettingsCampaignCommitteeRoute
  '/app/settings/campaign-preferences': typeof AppSettingsCampaignPreferencesRoute
  '/app/settings/playbook': typeof AppSettingsPlaybookRoute
  '/app/work-orders/$workOrderId': typeof AppWorkOrdersWorkOrderIdRoute
  '/app/work-orders/voter-data': typeof AppWorkOrdersVoterDataRoute
  '/admin/assistant-telemetry': typeof AdminAssistantTelemetryIndexRoute
  '/admin/assistant-test': typeof AdminAssistantTestIndexRoute
  '/admin/finance/': typeof AdminFinanceIndexRoute
  '/admin/fundraising/': typeof AdminFundraisingIndexRoute
  '/app/analytics/': typeof AppAnalyticsIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/work-orders/': typeof AppWorkOrdersIndexRoute
  '/admin/assistant-telemetry/runs/$runId': typeof AdminAssistantTelemetryRunsRunIdRoute
  '/admin/finance/bank-transactions/$bankTransactionId': typeof AdminFinanceBankTransactionsBankTransactionIdRoute
  '/admin/finance/close/file': typeof AdminFinanceCloseFileRoute
  '/admin/finance/contacts/$contactId': typeof AdminFinanceContactsContactIdRoute
  '/admin/finance/contributions/$contributionId': typeof AdminFinanceContributionsContributionIdRoute
  '/admin/finance/expenditures/$expenditureId': typeof AdminFinanceExpendituresExpenditureIdRoute
  '/admin/finance/reports/$reportId': typeof AdminFinanceReportsReportIdRoute
  '/admin/finance/settings/audit-log': typeof AdminFinanceSettingsAuditLogRoute
  '/admin/finance/settings/bank-accounts': typeof AdminFinanceSettingsBankAccountsRoute
  '/admin/finance/settings/election-outcome': typeof AdminFinanceSettingsElectionOutcomeRoute
  '/admin/finance/settings/processors': typeof AdminFinanceSettingsProcessorsRoute
  '/admin/finance/settings/recurring': typeof AdminFinanceSettingsRecurringRoute
  '/admin/finance/settings/rules': typeof AdminFinanceSettingsRulesRoute
  '/admin/finance/settings/setup': typeof AdminFinanceSettingsSetupRoute
  '/admin/finance/settings/sources': typeof AdminFinanceSettingsSourcesRoute
  '/admin/fundraising/call-books/$sheetId': typeof AdminFundraisingCallBooksSheetIdRoute
  '/admin/fundraising/prospects/$prospectId': typeof AdminFundraisingProspectsProspectIdRoute
  '/app/analytics/canvassers/$userId': typeof AppAnalyticsCanvassersUserIdRoute
  '/app/analytics/vendors/$vendorId': typeof AppAnalyticsVendorsVendorIdRoute
  '/admin/finance/close/': typeof AdminFinanceCloseIndexRoute
  '/admin/finance/contacts': typeof AdminFinanceContactsIndexRoute
  '/admin/finance/contributions': typeof AdminFinanceContributionsIndexRoute
  '/admin/finance/debts': typeof AdminFinanceDebtsIndexRoute
  '/admin/finance/expenditures': typeof AdminFinanceExpendituresIndexRoute
  '/admin/finance/loans': typeof AdminFinanceLoansIndexRoute
  '/admin/finance/reports': typeof AdminFinanceReportsIndexRoute
  '/admin/finance/settings/': typeof AdminFinanceSettingsIndexRoute
  '/admin/fundraising/call-books': typeof AdminFundraisingCallBooksIndexRoute
  '/admin/fundraising/prospects': typeof AdminFundraisingProspectsIndexRoute
  '/admin/finance/settings/contacts/$contactId': typeof AdminFinanceSettingsContactsContactIdRoute
  '/app/analytics/questions/$questionId/answers': typeof AppAnalyticsQuestionsQuestionIdAnswersRoute
  '/admin/finance/settings/contacts': typeof AdminFinanceSettingsContactsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/complete-registration': typeof CompleteRegistrationRoute
  '/dashboard': typeof DashboardRoute
  '/early': typeof EarlyRoute
  '/eula': typeof EulaRoute
  '/get-started': typeof GetStartedRoute
  '/login': typeof LoginRoute
  '/oauth-callback': typeof OauthCallbackRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/win-number': typeof WinNumberRoute
  '/admin/campaign-settings': typeof AdminCampaignSettingsRoute
  '/admin/election-outcomes': typeof AdminElectionOutcomesRoute
  '/admin/resources': typeof AdminResourcesRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/voter-data': typeof AdminVoterDataRoute
  '/app/field-ops': typeof AppFieldOpsRoute
  '/app/home': typeof AppHomeRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/vote-goal': typeof AppVoteGoalRoute
  '/donate/$slug': typeof DonateSlugRoute
  '/embed/$slug': typeof EmbedSlugRoute
  '/express/$code': typeof ExpressCodeRoute
  '/express/send': typeof ExpressSendRoute
  '/legal/accept': typeof LegalAcceptRoute
  '/subscribe/complete': typeof SubscribeCompleteRoute
  '/text-status/$token': typeof TextStatusTokenRoute
  '/voter-list/$token': typeof VoterListTokenRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/subscribe': typeof SubscribeIndexRoute
  '/$subsidiary/donate/$slug': typeof SubsidiaryDonateSlugRoute
  '/admin/finance/audit-log': typeof AdminFinanceAuditLogRoute
  '/admin/finance/deadlines': typeof AdminFinanceDeadlinesRoute
  '/admin/finance/filings': typeof AdminFinanceFilingsRoute
  '/admin/finance/inbox': typeof AdminFinanceInboxRoute
  '/admin/finance/payments': typeof AdminFinancePaymentsRoute
  '/admin/finance/setup': typeof AdminFinanceSetupRoute
  '/admin/finance/sources': typeof AdminFinanceSourcesRoute
  '/admin/finance/staged': typeof AdminFinanceStagedRoute
  '/admin/finance/transactions': typeof AdminFinanceTransactionsRoute
  '/admin/fundraising/commitments': typeof AdminFundraisingCommitmentsRoute
  '/admin/fundraising/follow-ups': typeof AdminFundraisingFollowUpsRoute
  '/admin/fundraising/match-review': typeof AdminFundraisingMatchReviewRoute
  '/admin/messaging/profile': typeof AdminMessagingProfileRoute
  '/admin/messaging/profiles': typeof AdminMessagingProfilesRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/settings/campaign-committee': typeof AppSettingsCampaignCommitteeRoute
  '/app/settings/campaign-preferences': typeof AppSettingsCampaignPreferencesRoute
  '/app/settings/playbook': typeof AppSettingsPlaybookRoute
  '/app/work-orders/$workOrderId': typeof AppWorkOrdersWorkOrderIdRoute
  '/app/work-orders/voter-data': typeof AppWorkOrdersVoterDataRoute
  '/admin/assistant-telemetry': typeof AdminAssistantTelemetryIndexRoute
  '/admin/assistant-test': typeof AdminAssistantTestIndexRoute
  '/admin/finance': typeof AdminFinanceIndexRoute
  '/admin/fundraising': typeof AdminFundraisingIndexRoute
  '/app/analytics': typeof AppAnalyticsIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/work-orders': typeof AppWorkOrdersIndexRoute
  '/admin/assistant-telemetry/runs/$runId': typeof AdminAssistantTelemetryRunsRunIdRoute
  '/admin/finance/bank-transactions/$bankTransactionId': typeof AdminFinanceBankTransactionsBankTransactionIdRoute
  '/admin/finance/close/file': typeof AdminFinanceCloseFileRoute
  '/admin/finance/contacts/$contactId': typeof AdminFinanceContactsContactIdRoute
  '/admin/finance/contributions/$contributionId': typeof AdminFinanceContributionsContributionIdRoute
  '/admin/finance/expenditures/$expenditureId': typeof AdminFinanceExpendituresExpenditureIdRoute
  '/admin/finance/reports/$reportId': typeof AdminFinanceReportsReportIdRoute
  '/admin/finance/settings/audit-log': typeof AdminFinanceSettingsAuditLogRoute
  '/admin/finance/settings/bank-accounts': typeof AdminFinanceSettingsBankAccountsRoute
  '/admin/finance/settings/election-outcome': typeof AdminFinanceSettingsElectionOutcomeRoute
  '/admin/finance/settings/processors': typeof AdminFinanceSettingsProcessorsRoute
  '/admin/finance/settings/recurring': typeof AdminFinanceSettingsRecurringRoute
  '/admin/finance/settings/rules': typeof AdminFinanceSettingsRulesRoute
  '/admin/finance/settings/setup': typeof AdminFinanceSettingsSetupRoute
  '/admin/finance/settings/sources': typeof AdminFinanceSettingsSourcesRoute
  '/admin/fundraising/call-books/$sheetId': typeof AdminFundraisingCallBooksSheetIdRoute
  '/admin/fundraising/prospects/$prospectId': typeof AdminFundraisingProspectsProspectIdRoute
  '/app/analytics/canvassers/$userId': typeof AppAnalyticsCanvassersUserIdRoute
  '/app/analytics/vendors/$vendorId': typeof AppAnalyticsVendorsVendorIdRoute
  '/admin/finance/close': typeof AdminFinanceCloseIndexRoute
  '/admin/finance/contacts': typeof AdminFinanceContactsIndexRoute
  '/admin/finance/contributions': typeof AdminFinanceContributionsIndexRoute
  '/admin/finance/debts': typeof AdminFinanceDebtsIndexRoute
  '/admin/finance/expenditures': typeof AdminFinanceExpendituresIndexRoute
  '/admin/finance/loans': typeof AdminFinanceLoansIndexRoute
  '/admin/finance/reports': typeof AdminFinanceReportsIndexRoute
  '/admin/finance/settings': typeof AdminFinanceSettingsIndexRoute
  '/admin/fundraising/call-books': typeof AdminFundraisingCallBooksIndexRoute
  '/admin/fundraising/prospects': typeof AdminFundraisingProspectsIndexRoute
  '/admin/finance/settings/contacts/$contactId': typeof AdminFinanceSettingsContactsContactIdRoute
  '/app/analytics/questions/$questionId/answers': typeof AppAnalyticsQuestionsQuestionIdAnswersRoute
  '/admin/finance/settings/contacts': typeof AdminFinanceSettingsContactsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/complete-registration': typeof CompleteRegistrationRoute
  '/dashboard': typeof DashboardRoute
  '/early': typeof EarlyRoute
  '/eula': typeof EulaRoute
  '/get-started': typeof GetStartedRoute
  '/login': typeof LoginRoute
  '/oauth-callback': typeof OauthCallbackRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/win-number': typeof WinNumberRoute
  '/app/work-orders': typeof AppWorkOrdersRouteRouteWithChildren
  '/admin/campaign-settings': typeof AdminCampaignSettingsRoute
  '/admin/election-outcomes': typeof AdminElectionOutcomesRoute
  '/admin/finance': typeof AdminFinanceRouteWithChildren
  '/admin/fundraising': typeof AdminFundraisingRouteWithChildren
  '/admin/resources': typeof AdminResourcesRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/voter-data': typeof AdminVoterDataRoute
  '/app/analytics': typeof AppAnalyticsRouteWithChildren
  '/app/field-ops': typeof AppFieldOpsRoute
  '/app/home': typeof AppHomeRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/vote-goal': typeof AppVoteGoalRoute
  '/donate/$slug': typeof DonateSlugRoute
  '/embed/$slug': typeof EmbedSlugRoute
  '/express/$code': typeof ExpressCodeRoute
  '/express/send': typeof ExpressSendRoute
  '/legal/accept': typeof LegalAcceptRoute
  '/subscribe/complete': typeof SubscribeCompleteRoute
  '/text-status/$token': typeof TextStatusTokenRoute
  '/voter-list/$token': typeof VoterListTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/subscribe/': typeof SubscribeIndexRoute
  '/$subsidiary/donate/$slug': typeof SubsidiaryDonateSlugRoute
  '/admin/finance/audit-log': typeof AdminFinanceAuditLogRoute
  '/admin/finance/close': typeof AdminFinanceCloseRouteWithChildren
  '/admin/finance/deadlines': typeof AdminFinanceDeadlinesRoute
  '/admin/finance/filings': typeof AdminFinanceFilingsRoute
  '/admin/finance/inbox': typeof AdminFinanceInboxRoute
  '/admin/finance/payments': typeof AdminFinancePaymentsRoute
  '/admin/finance/settings': typeof AdminFinanceSettingsRouteWithChildren
  '/admin/finance/setup': typeof AdminFinanceSetupRoute
  '/admin/finance/sources': typeof AdminFinanceSourcesRoute
  '/admin/finance/staged': typeof AdminFinanceStagedRoute
  '/admin/finance/transactions': typeof AdminFinanceTransactionsRoute
  '/admin/fundraising/commitments': typeof AdminFundraisingCommitmentsRoute
  '/admin/fundraising/follow-ups': typeof AdminFundraisingFollowUpsRoute
  '/admin/fundraising/match-review': typeof AdminFundraisingMatchReviewRoute
  '/admin/messaging/profile': typeof AdminMessagingProfileRoute
  '/admin/messaging/profiles': typeof AdminMessagingProfilesRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/settings/campaign-committee': typeof AppSettingsCampaignCommitteeRoute
  '/app/settings/campaign-preferences': typeof AppSettingsCampaignPreferencesRoute
  '/app/settings/playbook': typeof AppSettingsPlaybookRoute
  '/app/work-orders/$workOrderId': typeof AppWorkOrdersWorkOrderIdRoute
  '/app/work-orders/voter-data': typeof AppWorkOrdersVoterDataRoute
  '/admin/assistant-telemetry/': typeof AdminAssistantTelemetryIndexRoute
  '/admin/assistant-test/': typeof AdminAssistantTestIndexRoute
  '/admin/finance/': typeof AdminFinanceIndexRoute
  '/admin/fundraising/': typeof AdminFundraisingIndexRoute
  '/app/analytics/': typeof AppAnalyticsIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/work-orders/': typeof AppWorkOrdersIndexRoute
  '/admin/assistant-telemetry/runs/$runId': typeof AdminAssistantTelemetryRunsRunIdRoute
  '/admin/finance/bank-transactions/$bankTransactionId': typeof AdminFinanceBankTransactionsBankTransactionIdRoute
  '/admin/finance/close/file': typeof AdminFinanceCloseFileRoute
  '/admin/finance/contacts/$contactId': typeof AdminFinanceContactsContactIdRoute
  '/admin/finance/contributions/$contributionId': typeof AdminFinanceContributionsContributionIdRoute
  '/admin/finance/expenditures/$expenditureId': typeof AdminFinanceExpendituresExpenditureIdRoute
  '/admin/finance/reports/$reportId': typeof AdminFinanceReportsReportIdRoute
  '/admin/finance/settings/audit-log': typeof AdminFinanceSettingsAuditLogRoute
  '/admin/finance/settings/bank-accounts': typeof AdminFinanceSettingsBankAccountsRoute
  '/admin/finance/settings/election-outcome': typeof AdminFinanceSettingsElectionOutcomeRoute
  '/admin/finance/settings/processors': typeof AdminFinanceSettingsProcessorsRoute
  '/admin/finance/settings/recurring': typeof AdminFinanceSettingsRecurringRoute
  '/admin/finance/settings/rules': typeof AdminFinanceSettingsRulesRoute
  '/admin/finance/settings/setup': typeof AdminFinanceSettingsSetupRoute
  '/admin/finance/settings/sources': typeof AdminFinanceSettingsSourcesRoute
  '/admin/fundraising/call-books/$sheetId': typeof AdminFundraisingCallBooksSheetIdRoute
  '/admin/fundraising/prospects/$prospectId': typeof AdminFundraisingProspectsProspectIdRoute
  '/app/analytics/canvassers/$userId': typeof AppAnalyticsCanvassersUserIdRoute
  '/app/analytics/vendors/$vendorId': typeof AppAnalyticsVendorsVendorIdRoute
  '/admin/finance/close/': typeof AdminFinanceCloseIndexRoute
  '/admin/finance/contacts/': typeof AdminFinanceContactsIndexRoute
  '/admin/finance/contributions/': typeof AdminFinanceContributionsIndexRoute
  '/admin/finance/debts/': typeof AdminFinanceDebtsIndexRoute
  '/admin/finance/expenditures/': typeof AdminFinanceExpendituresIndexRoute
  '/admin/finance/loans/': typeof AdminFinanceLoansIndexRoute
  '/admin/finance/reports/': typeof AdminFinanceReportsIndexRoute
  '/admin/finance/settings/': typeof AdminFinanceSettingsIndexRoute
  '/admin/fundraising/call-books/': typeof AdminFundraisingCallBooksIndexRoute
  '/admin/fundraising/prospects/': typeof AdminFundraisingProspectsIndexRoute
  '/admin/finance/settings/contacts/$contactId': typeof AdminFinanceSettingsContactsContactIdRoute
  '/app/analytics/questions/$questionId/answers': typeof AppAnalyticsQuestionsQuestionIdAnswersRoute
  '/admin/finance/settings/contacts/': typeof AdminFinanceSettingsContactsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/$'
    | '/complete-registration'
    | '/dashboard'
    | '/early'
    | '/eula'
    | '/get-started'
    | '/login'
    | '/oauth-callback'
    | '/privacy-policy'
    | '/reset-password'
    | '/security'
    | '/support'
    | '/terms'
    | '/win-number'
    | '/app/work-orders'
    | '/admin/campaign-settings'
    | '/admin/election-outcomes'
    | '/admin/finance'
    | '/admin/fundraising'
    | '/admin/resources'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/tags'
    | '/admin/voter-data'
    | '/app/analytics'
    | '/app/field-ops'
    | '/app/home'
    | '/app/onboarding'
    | '/app/settings'
    | '/app/vote-goal'
    | '/donate/$slug'
    | '/embed/$slug'
    | '/express/$code'
    | '/express/send'
    | '/legal/accept'
    | '/subscribe/complete'
    | '/text-status/$token'
    | '/voter-list/$token'
    | '/admin/'
    | '/app/'
    | '/subscribe'
    | '/$subsidiary/donate/$slug'
    | '/admin/finance/audit-log'
    | '/admin/finance/close'
    | '/admin/finance/deadlines'
    | '/admin/finance/filings'
    | '/admin/finance/inbox'
    | '/admin/finance/payments'
    | '/admin/finance/settings'
    | '/admin/finance/setup'
    | '/admin/finance/sources'
    | '/admin/finance/staged'
    | '/admin/finance/transactions'
    | '/admin/fundraising/commitments'
    | '/admin/fundraising/follow-ups'
    | '/admin/fundraising/match-review'
    | '/admin/messaging/profile'
    | '/admin/messaging/profiles'
    | '/app/settings/billing'
    | '/app/settings/campaign-committee'
    | '/app/settings/campaign-preferences'
    | '/app/settings/playbook'
    | '/app/work-orders/$workOrderId'
    | '/app/work-orders/voter-data'
    | '/admin/assistant-telemetry'
    | '/admin/assistant-test'
    | '/admin/finance/'
    | '/admin/fundraising/'
    | '/app/analytics/'
    | '/app/settings/'
    | '/app/work-orders/'
    | '/admin/assistant-telemetry/runs/$runId'
    | '/admin/finance/bank-transactions/$bankTransactionId'
    | '/admin/finance/close/file'
    | '/admin/finance/contacts/$contactId'
    | '/admin/finance/contributions/$contributionId'
    | '/admin/finance/expenditures/$expenditureId'
    | '/admin/finance/reports/$reportId'
    | '/admin/finance/settings/audit-log'
    | '/admin/finance/settings/bank-accounts'
    | '/admin/finance/settings/election-outcome'
    | '/admin/finance/settings/processors'
    | '/admin/finance/settings/recurring'
    | '/admin/finance/settings/rules'
    | '/admin/finance/settings/setup'
    | '/admin/finance/settings/sources'
    | '/admin/fundraising/call-books/$sheetId'
    | '/admin/fundraising/prospects/$prospectId'
    | '/app/analytics/canvassers/$userId'
    | '/app/analytics/vendors/$vendorId'
    | '/admin/finance/close/'
    | '/admin/finance/contacts'
    | '/admin/finance/contributions'
    | '/admin/finance/debts'
    | '/admin/finance/expenditures'
    | '/admin/finance/loans'
    | '/admin/finance/reports'
    | '/admin/finance/settings/'
    | '/admin/fundraising/call-books'
    | '/admin/fundraising/prospects'
    | '/admin/finance/settings/contacts/$contactId'
    | '/app/analytics/questions/$questionId/answers'
    | '/admin/finance/settings/contacts'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/complete-registration'
    | '/dashboard'
    | '/early'
    | '/eula'
    | '/get-started'
    | '/login'
    | '/oauth-callback'
    | '/privacy-policy'
    | '/reset-password'
    | '/security'
    | '/support'
    | '/terms'
    | '/win-number'
    | '/admin/campaign-settings'
    | '/admin/election-outcomes'
    | '/admin/resources'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/tags'
    | '/admin/voter-data'
    | '/app/field-ops'
    | '/app/home'
    | '/app/onboarding'
    | '/app/vote-goal'
    | '/donate/$slug'
    | '/embed/$slug'
    | '/express/$code'
    | '/express/send'
    | '/legal/accept'
    | '/subscribe/complete'
    | '/text-status/$token'
    | '/voter-list/$token'
    | '/admin'
    | '/app'
    | '/subscribe'
    | '/$subsidiary/donate/$slug'
    | '/admin/finance/audit-log'
    | '/admin/finance/deadlines'
    | '/admin/finance/filings'
    | '/admin/finance/inbox'
    | '/admin/finance/payments'
    | '/admin/finance/setup'
    | '/admin/finance/sources'
    | '/admin/finance/staged'
    | '/admin/finance/transactions'
    | '/admin/fundraising/commitments'
    | '/admin/fundraising/follow-ups'
    | '/admin/fundraising/match-review'
    | '/admin/messaging/profile'
    | '/admin/messaging/profiles'
    | '/app/settings/billing'
    | '/app/settings/campaign-committee'
    | '/app/settings/campaign-preferences'
    | '/app/settings/playbook'
    | '/app/work-orders/$workOrderId'
    | '/app/work-orders/voter-data'
    | '/admin/assistant-telemetry'
    | '/admin/assistant-test'
    | '/admin/finance'
    | '/admin/fundraising'
    | '/app/analytics'
    | '/app/settings'
    | '/app/work-orders'
    | '/admin/assistant-telemetry/runs/$runId'
    | '/admin/finance/bank-transactions/$bankTransactionId'
    | '/admin/finance/close/file'
    | '/admin/finance/contacts/$contactId'
    | '/admin/finance/contributions/$contributionId'
    | '/admin/finance/expenditures/$expenditureId'
    | '/admin/finance/reports/$reportId'
    | '/admin/finance/settings/audit-log'
    | '/admin/finance/settings/bank-accounts'
    | '/admin/finance/settings/election-outcome'
    | '/admin/finance/settings/processors'
    | '/admin/finance/settings/recurring'
    | '/admin/finance/settings/rules'
    | '/admin/finance/settings/setup'
    | '/admin/finance/settings/sources'
    | '/admin/fundraising/call-books/$sheetId'
    | '/admin/fundraising/prospects/$prospectId'
    | '/app/analytics/canvassers/$userId'
    | '/app/analytics/vendors/$vendorId'
    | '/admin/finance/close'
    | '/admin/finance/contacts'
    | '/admin/finance/contributions'
    | '/admin/finance/debts'
    | '/admin/finance/expenditures'
    | '/admin/finance/loans'
    | '/admin/finance/reports'
    | '/admin/finance/settings'
    | '/admin/fundraising/call-books'
    | '/admin/fundraising/prospects'
    | '/admin/finance/settings/contacts/$contactId'
    | '/app/analytics/questions/$questionId/answers'
    | '/admin/finance/settings/contacts'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/$'
    | '/complete-registration'
    | '/dashboard'
    | '/early'
    | '/eula'
    | '/get-started'
    | '/login'
    | '/oauth-callback'
    | '/privacy-policy'
    | '/reset-password'
    | '/security'
    | '/support'
    | '/terms'
    | '/win-number'
    | '/app/work-orders'
    | '/admin/campaign-settings'
    | '/admin/election-outcomes'
    | '/admin/finance'
    | '/admin/fundraising'
    | '/admin/resources'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/tags'
    | '/admin/voter-data'
    | '/app/analytics'
    | '/app/field-ops'
    | '/app/home'
    | '/app/onboarding'
    | '/app/settings'
    | '/app/vote-goal'
    | '/donate/$slug'
    | '/embed/$slug'
    | '/express/$code'
    | '/express/send'
    | '/legal/accept'
    | '/subscribe/complete'
    | '/text-status/$token'
    | '/voter-list/$token'
    | '/admin/'
    | '/app/'
    | '/subscribe/'
    | '/$subsidiary/donate/$slug'
    | '/admin/finance/audit-log'
    | '/admin/finance/close'
    | '/admin/finance/deadlines'
    | '/admin/finance/filings'
    | '/admin/finance/inbox'
    | '/admin/finance/payments'
    | '/admin/finance/settings'
    | '/admin/finance/setup'
    | '/admin/finance/sources'
    | '/admin/finance/staged'
    | '/admin/finance/transactions'
    | '/admin/fundraising/commitments'
    | '/admin/fundraising/follow-ups'
    | '/admin/fundraising/match-review'
    | '/admin/messaging/profile'
    | '/admin/messaging/profiles'
    | '/app/settings/billing'
    | '/app/settings/campaign-committee'
    | '/app/settings/campaign-preferences'
    | '/app/settings/playbook'
    | '/app/work-orders/$workOrderId'
    | '/app/work-orders/voter-data'
    | '/admin/assistant-telemetry/'
    | '/admin/assistant-test/'
    | '/admin/finance/'
    | '/admin/fundraising/'
    | '/app/analytics/'
    | '/app/settings/'
    | '/app/work-orders/'
    | '/admin/assistant-telemetry/runs/$runId'
    | '/admin/finance/bank-transactions/$bankTransactionId'
    | '/admin/finance/close/file'
    | '/admin/finance/contacts/$contactId'
    | '/admin/finance/contributions/$contributionId'
    | '/admin/finance/expenditures/$expenditureId'
    | '/admin/finance/reports/$reportId'
    | '/admin/finance/settings/audit-log'
    | '/admin/finance/settings/bank-accounts'
    | '/admin/finance/settings/election-outcome'
    | '/admin/finance/settings/processors'
    | '/admin/finance/settings/recurring'
    | '/admin/finance/settings/rules'
    | '/admin/finance/settings/setup'
    | '/admin/finance/settings/sources'
    | '/admin/fundraising/call-books/$sheetId'
    | '/admin/fundraising/prospects/$prospectId'
    | '/app/analytics/canvassers/$userId'
    | '/app/analytics/vendors/$vendorId'
    | '/admin/finance/close/'
    | '/admin/finance/contacts/'
    | '/admin/finance/contributions/'
    | '/admin/finance/debts/'
    | '/admin/finance/expenditures/'
    | '/admin/finance/loans/'
    | '/admin/finance/reports/'
    | '/admin/finance/settings/'
    | '/admin/fundraising/call-books/'
    | '/admin/fundraising/prospects/'
    | '/admin/finance/settings/contacts/$contactId'
    | '/app/analytics/questions/$questionId/answers'
    | '/admin/finance/settings/contacts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AppRouteRoute: typeof AppRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  CompleteRegistrationRoute: typeof CompleteRegistrationRoute
  DashboardRoute: typeof DashboardRoute
  EarlyRoute: typeof EarlyRoute
  EulaRoute: typeof EulaRoute
  GetStartedRoute: typeof GetStartedRoute
  LoginRoute: typeof LoginRoute
  OauthCallbackRoute: typeof OauthCallbackRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SecurityRoute: typeof SecurityRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
  WinNumberRoute: typeof WinNumberRoute
  DonateSlugRoute: typeof DonateSlugRoute
  EmbedSlugRoute: typeof EmbedSlugRoute
  ExpressCodeRoute: typeof ExpressCodeRoute
  ExpressSendRoute: typeof ExpressSendRoute
  LegalAcceptRoute: typeof LegalAcceptRoute
  SubscribeCompleteRoute: typeof SubscribeCompleteRoute
  TextStatusTokenRoute: typeof TextStatusTokenRoute
  VoterListTokenRoute: typeof VoterListTokenRoute
  SubscribeIndexRoute: typeof SubscribeIndexRoute
  SubsidiaryDonateSlugRoute: typeof SubsidiaryDonateSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/win-number': {
      id: '/win-number'
      path: '/win-number'
      fullPath: '/win-number'
      preLoaderRoute: typeof WinNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth-callback': {
      id: '/oauth-callback'
      path: '/oauth-callback'
      fullPath: '/oauth-callback'
      preLoaderRoute: typeof OauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eula': {
      id: '/eula'
      path: '/eula'
      fullPath: '/eula'
      preLoaderRoute: typeof EulaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/early': {
      id: '/early'
      path: '/early'
      fullPath: '/early'
      preLoaderRoute: typeof EarlyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-registration': {
      id: '/complete-registration'
      path: '/complete-registration'
      fullPath: '/complete-registration'
      preLoaderRoute: typeof CompleteRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe/': {
      id: '/subscribe/'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof SubscribeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/voter-list/$token': {
      id: '/voter-list/$token'
      path: '/voter-list/$token'
      fullPath: '/voter-list/$token'
      preLoaderRoute: typeof VoterListTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/text-status/$token': {
      id: '/text-status/$token'
      path: '/text-status/$token'
      fullPath: '/text-status/$token'
      preLoaderRoute: typeof TextStatusTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe/complete': {
      id: '/subscribe/complete'
      path: '/subscribe/complete'
      fullPath: '/subscribe/complete'
      preLoaderRoute: typeof SubscribeCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/accept': {
      id: '/legal/accept'
      path: '/legal/accept'
      fullPath: '/legal/accept'
      preLoaderRoute: typeof LegalAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/express/send': {
      id: '/express/send'
      path: '/express/send'
      fullPath: '/express/send'
      preLoaderRoute: typeof ExpressSendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/express/$code': {
      id: '/express/$code'
      path: '/express/$code'
      fullPath: '/express/$code'
      preLoaderRoute: typeof ExpressCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/$slug': {
      id: '/embed/$slug'
      path: '/embed/$slug'
      fullPath: '/embed/$slug'
      preLoaderRoute: typeof EmbedSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate/$slug': {
      id: '/donate/$slug'
      path: '/donate/$slug'
      fullPath: '/donate/$slug'
      preLoaderRoute: typeof DonateSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/vote-goal': {
      id: '/app/vote-goal'
      path: '/vote-goal'
      fullPath: '/app/vote-goal'
      preLoaderRoute: typeof AppVoteGoalRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/home': {
      id: '/app/home'
      path: '/home'
      fullPath: '/app/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/field-ops': {
      id: '/app/field-ops'
      path: '/field-ops'
      fullPath: '/app/field-ops'
      preLoaderRoute: typeof AppFieldOpsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/analytics': {
      id: '/app/analytics'
      path: '/analytics'
      fullPath: '/app/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/voter-data': {
      id: '/admin/voter-data'
      path: '/voter-data'
      fullPath: '/admin/voter-data'
      preLoaderRoute: typeof AdminVoterDataRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tags': {
      id: '/admin/tags'
      path: '/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AdminTagsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/resources': {
      id: '/admin/resources'
      path: '/resources'
      fullPath: '/admin/resources'
      preLoaderRoute: typeof AdminResourcesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/fundraising': {
      id: '/admin/fundraising'
      path: '/fundraising'
      fullPath: '/admin/fundraising'
      preLoaderRoute: typeof AdminFundraisingRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/finance': {
      id: '/admin/finance'
      path: '/finance'
      fullPath: '/admin/finance'
      preLoaderRoute: typeof AdminFinanceRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/election-outcomes': {
      id: '/admin/election-outcomes'
      path: '/election-outcomes'
      fullPath: '/admin/election-outcomes'
      preLoaderRoute: typeof AdminElectionOutcomesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaign-settings': {
      id: '/admin/campaign-settings'
      path: '/campaign-settings'
      fullPath: '/admin/campaign-settings'
      preLoaderRoute: typeof AdminCampaignSettingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/app/work-orders': {
      id: '/app/work-orders'
      path: '/work-orders'
      fullPath: '/app/work-orders'
      preLoaderRoute: typeof AppWorkOrdersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/work-orders/': {
      id: '/app/work-orders/'
      path: '/'
      fullPath: '/app/work-orders/'
      preLoaderRoute: typeof AppWorkOrdersIndexRouteImport
      parentRoute: typeof AppWorkOrdersRouteRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/analytics/': {
      id: '/app/analytics/'
      path: '/'
      fullPath: '/app/analytics/'
      preLoaderRoute: typeof AppAnalyticsIndexRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/admin/fundraising/': {
      id: '/admin/fundraising/'
      path: '/'
      fullPath: '/admin/fundraising/'
      preLoaderRoute: typeof AdminFundraisingIndexRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/finance/': {
      id: '/admin/finance/'
      path: '/'
      fullPath: '/admin/finance/'
      preLoaderRoute: typeof AdminFinanceIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/assistant-test/': {
      id: '/admin/assistant-test/'
      path: '/assistant-test'
      fullPath: '/admin/assistant-test'
      preLoaderRoute: typeof AdminAssistantTestIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/assistant-telemetry/': {
      id: '/admin/assistant-telemetry/'
      path: '/assistant-telemetry'
      fullPath: '/admin/assistant-telemetry'
      preLoaderRoute: typeof AdminAssistantTelemetryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/app/work-orders/voter-data': {
      id: '/app/work-orders/voter-data'
      path: '/voter-data'
      fullPath: '/app/work-orders/voter-data'
      preLoaderRoute: typeof AppWorkOrdersVoterDataRouteImport
      parentRoute: typeof AppWorkOrdersRouteRoute
    }
    '/app/work-orders/$workOrderId': {
      id: '/app/work-orders/$workOrderId'
      path: '/$workOrderId'
      fullPath: '/app/work-orders/$workOrderId'
      preLoaderRoute: typeof AppWorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof AppWorkOrdersRouteRoute
    }
    '/app/settings/playbook': {
      id: '/app/settings/playbook'
      path: '/playbook'
      fullPath: '/app/settings/playbook'
      preLoaderRoute: typeof AppSettingsPlaybookRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/campaign-preferences': {
      id: '/app/settings/campaign-preferences'
      path: '/campaign-preferences'
      fullPath: '/app/settings/campaign-preferences'
      preLoaderRoute: typeof AppSettingsCampaignPreferencesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/campaign-committee': {
      id: '/app/settings/campaign-committee'
      path: '/campaign-committee'
      fullPath: '/app/settings/campaign-committee'
      preLoaderRoute: typeof AppSettingsCampaignCommitteeRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/billing': {
      id: '/app/settings/billing'
      path: '/billing'
      fullPath: '/app/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/admin/messaging/profiles': {
      id: '/admin/messaging/profiles'
      path: '/messaging/profiles'
      fullPath: '/admin/messaging/profiles'
      preLoaderRoute: typeof AdminMessagingProfilesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/messaging/profile': {
      id: '/admin/messaging/profile'
      path: '/messaging/profile'
      fullPath: '/admin/messaging/profile'
      preLoaderRoute: typeof AdminMessagingProfileRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/fundraising/match-review': {
      id: '/admin/fundraising/match-review'
      path: '/match-review'
      fullPath: '/admin/fundraising/match-review'
      preLoaderRoute: typeof AdminFundraisingMatchReviewRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/fundraising/follow-ups': {
      id: '/admin/fundraising/follow-ups'
      path: '/follow-ups'
      fullPath: '/admin/fundraising/follow-ups'
      preLoaderRoute: typeof AdminFundraisingFollowUpsRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/fundraising/commitments': {
      id: '/admin/fundraising/commitments'
      path: '/commitments'
      fullPath: '/admin/fundraising/commitments'
      preLoaderRoute: typeof AdminFundraisingCommitmentsRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/finance/transactions': {
      id: '/admin/finance/transactions'
      path: '/transactions'
      fullPath: '/admin/finance/transactions'
      preLoaderRoute: typeof AdminFinanceTransactionsRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/staged': {
      id: '/admin/finance/staged'
      path: '/staged'
      fullPath: '/admin/finance/staged'
      preLoaderRoute: typeof AdminFinanceStagedRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/sources': {
      id: '/admin/finance/sources'
      path: '/sources'
      fullPath: '/admin/finance/sources'
      preLoaderRoute: typeof AdminFinanceSourcesRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/setup': {
      id: '/admin/finance/setup'
      path: '/setup'
      fullPath: '/admin/finance/setup'
      preLoaderRoute: typeof AdminFinanceSetupRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/settings': {
      id: '/admin/finance/settings'
      path: '/settings'
      fullPath: '/admin/finance/settings'
      preLoaderRoute: typeof AdminFinanceSettingsRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/payments': {
      id: '/admin/finance/payments'
      path: '/payments'
      fullPath: '/admin/finance/payments'
      preLoaderRoute: typeof AdminFinancePaymentsRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/inbox': {
      id: '/admin/finance/inbox'
      path: '/inbox'
      fullPath: '/admin/finance/inbox'
      preLoaderRoute: typeof AdminFinanceInboxRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/filings': {
      id: '/admin/finance/filings'
      path: '/filings'
      fullPath: '/admin/finance/filings'
      preLoaderRoute: typeof AdminFinanceFilingsRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/deadlines': {
      id: '/admin/finance/deadlines'
      path: '/deadlines'
      fullPath: '/admin/finance/deadlines'
      preLoaderRoute: typeof AdminFinanceDeadlinesRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/close': {
      id: '/admin/finance/close'
      path: '/close'
      fullPath: '/admin/finance/close'
      preLoaderRoute: typeof AdminFinanceCloseRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/audit-log': {
      id: '/admin/finance/audit-log'
      path: '/audit-log'
      fullPath: '/admin/finance/audit-log'
      preLoaderRoute: typeof AdminFinanceAuditLogRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/$subsidiary/donate/$slug': {
      id: '/$subsidiary/donate/$slug'
      path: '/$subsidiary/donate/$slug'
      fullPath: '/$subsidiary/donate/$slug'
      preLoaderRoute: typeof SubsidiaryDonateSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/fundraising/prospects/': {
      id: '/admin/fundraising/prospects/'
      path: '/prospects'
      fullPath: '/admin/fundraising/prospects'
      preLoaderRoute: typeof AdminFundraisingProspectsIndexRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/fundraising/call-books/': {
      id: '/admin/fundraising/call-books/'
      path: '/call-books'
      fullPath: '/admin/fundraising/call-books'
      preLoaderRoute: typeof AdminFundraisingCallBooksIndexRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/finance/settings/': {
      id: '/admin/finance/settings/'
      path: '/'
      fullPath: '/admin/finance/settings/'
      preLoaderRoute: typeof AdminFinanceSettingsIndexRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/reports/': {
      id: '/admin/finance/reports/'
      path: '/reports'
      fullPath: '/admin/finance/reports'
      preLoaderRoute: typeof AdminFinanceReportsIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/loans/': {
      id: '/admin/finance/loans/'
      path: '/loans'
      fullPath: '/admin/finance/loans'
      preLoaderRoute: typeof AdminFinanceLoansIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/expenditures/': {
      id: '/admin/finance/expenditures/'
      path: '/expenditures'
      fullPath: '/admin/finance/expenditures'
      preLoaderRoute: typeof AdminFinanceExpendituresIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/debts/': {
      id: '/admin/finance/debts/'
      path: '/debts'
      fullPath: '/admin/finance/debts'
      preLoaderRoute: typeof AdminFinanceDebtsIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/contributions/': {
      id: '/admin/finance/contributions/'
      path: '/contributions'
      fullPath: '/admin/finance/contributions'
      preLoaderRoute: typeof AdminFinanceContributionsIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/contacts/': {
      id: '/admin/finance/contacts/'
      path: '/contacts'
      fullPath: '/admin/finance/contacts'
      preLoaderRoute: typeof AdminFinanceContactsIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/close/': {
      id: '/admin/finance/close/'
      path: '/'
      fullPath: '/admin/finance/close/'
      preLoaderRoute: typeof AdminFinanceCloseIndexRouteImport
      parentRoute: typeof AdminFinanceCloseRoute
    }
    '/app/analytics/vendors/$vendorId': {
      id: '/app/analytics/vendors/$vendorId'
      path: '/vendors/$vendorId'
      fullPath: '/app/analytics/vendors/$vendorId'
      preLoaderRoute: typeof AppAnalyticsVendorsVendorIdRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/app/analytics/canvassers/$userId': {
      id: '/app/analytics/canvassers/$userId'
      path: '/canvassers/$userId'
      fullPath: '/app/analytics/canvassers/$userId'
      preLoaderRoute: typeof AppAnalyticsCanvassersUserIdRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/admin/fundraising/prospects/$prospectId': {
      id: '/admin/fundraising/prospects/$prospectId'
      path: '/prospects/$prospectId'
      fullPath: '/admin/fundraising/prospects/$prospectId'
      preLoaderRoute: typeof AdminFundraisingProspectsProspectIdRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/fundraising/call-books/$sheetId': {
      id: '/admin/fundraising/call-books/$sheetId'
      path: '/call-books/$sheetId'
      fullPath: '/admin/fundraising/call-books/$sheetId'
      preLoaderRoute: typeof AdminFundraisingCallBooksSheetIdRouteImport
      parentRoute: typeof AdminFundraisingRoute
    }
    '/admin/finance/settings/sources': {
      id: '/admin/finance/settings/sources'
      path: '/sources'
      fullPath: '/admin/finance/settings/sources'
      preLoaderRoute: typeof AdminFinanceSettingsSourcesRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/settings/setup': {
      id: '/admin/finance/settings/setup'
      path: '/setup'
      fullPath: '/admin/finance/settings/setup'
      preLoaderRoute: typeof AdminFinanceSettingsSetupRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/settings/rules': {
      id: '/admin/finance/settings/rules'
      path: '/rules'
      fullPath: '/admin/finance/settings/rules'
      preLoaderRoute: typeof AdminFinanceSettingsRulesRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/settings/recurring': {
      id: '/admin/finance/settings/recurring'
      path: '/recurring'
      fullPath: '/admin/finance/settings/recurring'
      preLoaderRoute: typeof AdminFinanceSettingsRecurringRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/settings/processors': {
      id: '/admin/finance/settings/processors'
      path: '/processors'
      fullPath: '/admin/finance/settings/processors'
      preLoaderRoute: typeof AdminFinanceSettingsProcessorsRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/settings/election-outcome': {
      id: '/admin/finance/settings/election-outcome'
      path: '/election-outcome'
      fullPath: '/admin/finance/settings/election-outcome'
      preLoaderRoute: typeof AdminFinanceSettingsElectionOutcomeRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/settings/bank-accounts': {
      id: '/admin/finance/settings/bank-accounts'
      path: '/bank-accounts'
      fullPath: '/admin/finance/settings/bank-accounts'
      preLoaderRoute: typeof AdminFinanceSettingsBankAccountsRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/settings/audit-log': {
      id: '/admin/finance/settings/audit-log'
      path: '/audit-log'
      fullPath: '/admin/finance/settings/audit-log'
      preLoaderRoute: typeof AdminFinanceSettingsAuditLogRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/admin/finance/reports/$reportId': {
      id: '/admin/finance/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/admin/finance/reports/$reportId'
      preLoaderRoute: typeof AdminFinanceReportsReportIdRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/expenditures/$expenditureId': {
      id: '/admin/finance/expenditures/$expenditureId'
      path: '/expenditures/$expenditureId'
      fullPath: '/admin/finance/expenditures/$expenditureId'
      preLoaderRoute: typeof AdminFinanceExpendituresExpenditureIdRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/contributions/$contributionId': {
      id: '/admin/finance/contributions/$contributionId'
      path: '/contributions/$contributionId'
      fullPath: '/admin/finance/contributions/$contributionId'
      preLoaderRoute: typeof AdminFinanceContributionsContributionIdRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/contacts/$contactId': {
      id: '/admin/finance/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/admin/finance/contacts/$contactId'
      preLoaderRoute: typeof AdminFinanceContactsContactIdRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/close/file': {
      id: '/admin/finance/close/file'
      path: '/file'
      fullPath: '/admin/finance/close/file'
      preLoaderRoute: typeof AdminFinanceCloseFileRouteImport
      parentRoute: typeof AdminFinanceCloseRoute
    }
    '/admin/finance/bank-transactions/$bankTransactionId': {
      id: '/admin/finance/bank-transactions/$bankTransactionId'
      path: '/bank-transactions/$bankTransactionId'
      fullPath: '/admin/finance/bank-transactions/$bankTransactionId'
      preLoaderRoute: typeof AdminFinanceBankTransactionsBankTransactionIdRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/assistant-telemetry/runs/$runId': {
      id: '/admin/assistant-telemetry/runs/$runId'
      path: '/assistant-telemetry/runs/$runId'
      fullPath: '/admin/assistant-telemetry/runs/$runId'
      preLoaderRoute: typeof AdminAssistantTelemetryRunsRunIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/finance/settings/contacts/': {
      id: '/admin/finance/settings/contacts/'
      path: '/contacts'
      fullPath: '/admin/finance/settings/contacts'
      preLoaderRoute: typeof AdminFinanceSettingsContactsIndexRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
    '/app/analytics/questions/$questionId/answers': {
      id: '/app/analytics/questions/$questionId/answers'
      path: '/questions/$questionId/answers'
      fullPath: '/app/analytics/questions/$questionId/answers'
      preLoaderRoute: typeof AppAnalyticsQuestionsQuestionIdAnswersRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/admin/finance/settings/contacts/$contactId': {
      id: '/admin/finance/settings/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/admin/finance/settings/contacts/$contactId'
      preLoaderRoute: typeof AdminFinanceSettingsContactsContactIdRouteImport
      parentRoute: typeof AdminFinanceSettingsRoute
    }
  }
}

interface AdminFinanceCloseRouteChildren {
  AdminFinanceCloseFileRoute: typeof AdminFinanceCloseFileRoute
  AdminFinanceCloseIndexRoute: typeof AdminFinanceCloseIndexRoute
}

const AdminFinanceCloseRouteChildren: AdminFinanceCloseRouteChildren = {
  AdminFinanceCloseFileRoute: AdminFinanceCloseFileRoute,
  AdminFinanceCloseIndexRoute: AdminFinanceCloseIndexRoute,
}

const AdminFinanceCloseRouteWithChildren =
  AdminFinanceCloseRoute._addFileChildren(AdminFinanceCloseRouteChildren)

interface AdminFinanceSettingsRouteChildren {
  AdminFinanceSettingsAuditLogRoute: typeof AdminFinanceSettingsAuditLogRoute
  AdminFinanceSettingsBankAccountsRoute: typeof AdminFinanceSettingsBankAccountsRoute
  AdminFinanceSettingsElectionOutcomeRoute: typeof AdminFinanceSettingsElectionOutcomeRoute
  AdminFinanceSettingsProcessorsRoute: typeof AdminFinanceSettingsProcessorsRoute
  AdminFinanceSettingsRecurringRoute: typeof AdminFinanceSettingsRecurringRoute
  AdminFinanceSettingsRulesRoute: typeof AdminFinanceSettingsRulesRoute
  AdminFinanceSettingsSetupRoute: typeof AdminFinanceSettingsSetupRoute
  AdminFinanceSettingsSourcesRoute: typeof AdminFinanceSettingsSourcesRoute
  AdminFinanceSettingsIndexRoute: typeof AdminFinanceSettingsIndexRoute
  AdminFinanceSettingsContactsContactIdRoute: typeof AdminFinanceSettingsContactsContactIdRoute
  AdminFinanceSettingsContactsIndexRoute: typeof AdminFinanceSettingsContactsIndexRoute
}

const AdminFinanceSettingsRouteChildren: AdminFinanceSettingsRouteChildren = {
  AdminFinanceSettingsAuditLogRoute: AdminFinanceSettingsAuditLogRoute,
  AdminFinanceSettingsBankAccountsRoute: AdminFinanceSettingsBankAccountsRoute,
  AdminFinanceSettingsElectionOutcomeRoute:
    AdminFinanceSettingsElectionOutcomeRoute,
  AdminFinanceSettingsProcessorsRoute: AdminFinanceSettingsProcessorsRoute,
  AdminFinanceSettingsRecurringRoute: AdminFinanceSettingsRecurringRoute,
  AdminFinanceSettingsRulesRoute: AdminFinanceSettingsRulesRoute,
  AdminFinanceSettingsSetupRoute: AdminFinanceSettingsSetupRoute,
  AdminFinanceSettingsSourcesRoute: AdminFinanceSettingsSourcesRoute,
  AdminFinanceSettingsIndexRoute: AdminFinanceSettingsIndexRoute,
  AdminFinanceSettingsContactsContactIdRoute:
    AdminFinanceSettingsContactsContactIdRoute,
  AdminFinanceSettingsContactsIndexRoute:
    AdminFinanceSettingsContactsIndexRoute,
}

const AdminFinanceSettingsRouteWithChildren =
  AdminFinanceSettingsRoute._addFileChildren(AdminFinanceSettingsRouteChildren)

interface AdminFinanceRouteChildren {
  AdminFinanceAuditLogRoute: typeof AdminFinanceAuditLogRoute
  AdminFinanceCloseRoute: typeof AdminFinanceCloseRouteWithChildren
  AdminFinanceDeadlinesRoute: typeof AdminFinanceDeadlinesRoute
  AdminFinanceFilingsRoute: typeof AdminFinanceFilingsRoute
  AdminFinanceInboxRoute: typeof AdminFinanceInboxRoute
  AdminFinancePaymentsRoute: typeof AdminFinancePaymentsRoute
  AdminFinanceSettingsRoute: typeof AdminFinanceSettingsRouteWithChildren
  AdminFinanceSetupRoute: typeof AdminFinanceSetupRoute
  AdminFinanceSourcesRoute: typeof AdminFinanceSourcesRoute
  AdminFinanceStagedRoute: typeof AdminFinanceStagedRoute
  AdminFinanceTransactionsRoute: typeof AdminFinanceTransactionsRoute
  AdminFinanceIndexRoute: typeof AdminFinanceIndexRoute
  AdminFinanceBankTransactionsBankTransactionIdRoute: typeof AdminFinanceBankTransactionsBankTransactionIdRoute
  AdminFinanceContactsContactIdRoute: typeof AdminFinanceContactsContactIdRoute
  AdminFinanceContributionsContributionIdRoute: typeof AdminFinanceContributionsContributionIdRoute
  AdminFinanceExpendituresExpenditureIdRoute: typeof AdminFinanceExpendituresExpenditureIdRoute
  AdminFinanceReportsReportIdRoute: typeof AdminFinanceReportsReportIdRoute
  AdminFinanceContactsIndexRoute: typeof AdminFinanceContactsIndexRoute
  AdminFinanceContributionsIndexRoute: typeof AdminFinanceContributionsIndexRoute
  AdminFinanceDebtsIndexRoute: typeof AdminFinanceDebtsIndexRoute
  AdminFinanceExpendituresIndexRoute: typeof AdminFinanceExpendituresIndexRoute
  AdminFinanceLoansIndexRoute: typeof AdminFinanceLoansIndexRoute
  AdminFinanceReportsIndexRoute: typeof AdminFinanceReportsIndexRoute
}

const AdminFinanceRouteChildren: AdminFinanceRouteChildren = {
  AdminFinanceAuditLogRoute: AdminFinanceAuditLogRoute,
  AdminFinanceCloseRoute: AdminFinanceCloseRouteWithChildren,
  AdminFinanceDeadlinesRoute: AdminFinanceDeadlinesRoute,
  AdminFinanceFilingsRoute: AdminFinanceFilingsRoute,
  AdminFinanceInboxRoute: AdminFinanceInboxRoute,
  AdminFinancePaymentsRoute: AdminFinancePaymentsRoute,
  AdminFinanceSettingsRoute: AdminFinanceSettingsRouteWithChildren,
  AdminFinanceSetupRoute: AdminFinanceSetupRoute,
  AdminFinanceSourcesRoute: AdminFinanceSourcesRoute,
  AdminFinanceStagedRoute: AdminFinanceStagedRoute,
  AdminFinanceTransactionsRoute: AdminFinanceTransactionsRoute,
  AdminFinanceIndexRoute: AdminFinanceIndexRoute,
  AdminFinanceBankTransactionsBankTransactionIdRoute:
    AdminFinanceBankTransactionsBankTransactionIdRoute,
  AdminFinanceContactsContactIdRoute: AdminFinanceContactsContactIdRoute,
  AdminFinanceContributionsContributionIdRoute:
    AdminFinanceContributionsContributionIdRoute,
  AdminFinanceExpendituresExpenditureIdRoute:
    AdminFinanceExpendituresExpenditureIdRoute,
  AdminFinanceReportsReportIdRoute: AdminFinanceReportsReportIdRoute,
  AdminFinanceContactsIndexRoute: AdminFinanceContactsIndexRoute,
  AdminFinanceContributionsIndexRoute: AdminFinanceContributionsIndexRoute,
  AdminFinanceDebtsIndexRoute: AdminFinanceDebtsIndexRoute,
  AdminFinanceExpendituresIndexRoute: AdminFinanceExpendituresIndexRoute,
  AdminFinanceLoansIndexRoute: AdminFinanceLoansIndexRoute,
  AdminFinanceReportsIndexRoute: AdminFinanceReportsIndexRoute,
}

const AdminFinanceRouteWithChildren = AdminFinanceRoute._addFileChildren(
  AdminFinanceRouteChildren,
)

interface AdminFundraisingRouteChildren {
  AdminFundraisingCommitmentsRoute: typeof AdminFundraisingCommitmentsRoute
  AdminFundraisingFollowUpsRoute: typeof AdminFundraisingFollowUpsRoute
  AdminFundraisingMatchReviewRoute: typeof AdminFundraisingMatchReviewRoute
  AdminFundraisingIndexRoute: typeof AdminFundraisingIndexRoute
  AdminFundraisingCallBooksSheetIdRoute: typeof AdminFundraisingCallBooksSheetIdRoute
  AdminFundraisingProspectsProspectIdRoute: typeof AdminFundraisingProspectsProspectIdRoute
  AdminFundraisingCallBooksIndexRoute: typeof AdminFundraisingCallBooksIndexRoute
  AdminFundraisingProspectsIndexRoute: typeof AdminFundraisingProspectsIndexRoute
}

const AdminFundraisingRouteChildren: AdminFundraisingRouteChildren = {
  AdminFundraisingCommitmentsRoute: AdminFundraisingCommitmentsRoute,
  AdminFundraisingFollowUpsRoute: AdminFundraisingFollowUpsRoute,
  AdminFundraisingMatchReviewRoute: AdminFundraisingMatchReviewRoute,
  AdminFundraisingIndexRoute: AdminFundraisingIndexRoute,
  AdminFundraisingCallBooksSheetIdRoute: AdminFundraisingCallBooksSheetIdRoute,
  AdminFundraisingProspectsProspectIdRoute:
    AdminFundraisingProspectsProspectIdRoute,
  AdminFundraisingCallBooksIndexRoute: AdminFundraisingCallBooksIndexRoute,
  AdminFundraisingProspectsIndexRoute: AdminFundraisingProspectsIndexRoute,
}

const AdminFundraisingRouteWithChildren =
  AdminFundraisingRoute._addFileChildren(AdminFundraisingRouteChildren)

interface AdminRouteRouteChildren {
  AdminCampaignSettingsRoute: typeof AdminCampaignSettingsRoute
  AdminElectionOutcomesRoute: typeof AdminElectionOutcomesRoute
  AdminFinanceRoute: typeof AdminFinanceRouteWithChildren
  AdminFundraisingRoute: typeof AdminFundraisingRouteWithChildren
  AdminResourcesRoute: typeof AdminResourcesRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AdminTagsRoute: typeof AdminTagsRoute
  AdminVoterDataRoute: typeof AdminVoterDataRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminMessagingProfileRoute: typeof AdminMessagingProfileRoute
  AdminMessagingProfilesRoute: typeof AdminMessagingProfilesRoute
  AdminAssistantTelemetryIndexRoute: typeof AdminAssistantTelemetryIndexRoute
  AdminAssistantTestIndexRoute: typeof AdminAssistantTestIndexRoute
  AdminAssistantTelemetryRunsRunIdRoute: typeof AdminAssistantTelemetryRunsRunIdRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminCampaignSettingsRoute: AdminCampaignSettingsRoute,
  AdminElectionOutcomesRoute: AdminElectionOutcomesRoute,
  AdminFinanceRoute: AdminFinanceRouteWithChildren,
  AdminFundraisingRoute: AdminFundraisingRouteWithChildren,
  AdminResourcesRoute: AdminResourcesRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStaffRoute: AdminStaffRoute,
  AdminTagsRoute: AdminTagsRoute,
  AdminVoterDataRoute: AdminVoterDataRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminMessagingProfileRoute: AdminMessagingProfileRoute,
  AdminMessagingProfilesRoute: AdminMessagingProfilesRoute,
  AdminAssistantTelemetryIndexRoute: AdminAssistantTelemetryIndexRoute,
  AdminAssistantTestIndexRoute: AdminAssistantTestIndexRoute,
  AdminAssistantTelemetryRunsRunIdRoute: AdminAssistantTelemetryRunsRunIdRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AppWorkOrdersRouteRouteChildren {
  AppWorkOrdersWorkOrderIdRoute: typeof AppWorkOrdersWorkOrderIdRoute
  AppWorkOrdersVoterDataRoute: typeof AppWorkOrdersVoterDataRoute
  AppWorkOrdersIndexRoute: typeof AppWorkOrdersIndexRoute
}

const AppWorkOrdersRouteRouteChildren: AppWorkOrdersRouteRouteChildren = {
  AppWorkOrdersWorkOrderIdRoute: AppWorkOrdersWorkOrderIdRoute,
  AppWorkOrdersVoterDataRoute: AppWorkOrdersVoterDataRoute,
  AppWorkOrdersIndexRoute: AppWorkOrdersIndexRoute,
}

const AppWorkOrdersRouteRouteWithChildren =
  AppWorkOrdersRouteRoute._addFileChildren(AppWorkOrdersRouteRouteChildren)

interface AppAnalyticsRouteChildren {
  AppAnalyticsIndexRoute: typeof AppAnalyticsIndexRoute
  AppAnalyticsCanvassersUserIdRoute: typeof AppAnalyticsCanvassersUserIdRoute
  AppAnalyticsVendorsVendorIdRoute: typeof AppAnalyticsVendorsVendorIdRoute
  AppAnalyticsQuestionsQuestionIdAnswersRoute: typeof AppAnalyticsQuestionsQuestionIdAnswersRoute
}

const AppAnalyticsRouteChildren: AppAnalyticsRouteChildren = {
  AppAnalyticsIndexRoute: AppAnalyticsIndexRoute,
  AppAnalyticsCanvassersUserIdRoute: AppAnalyticsCanvassersUserIdRoute,
  AppAnalyticsVendorsVendorIdRoute: AppAnalyticsVendorsVendorIdRoute,
  AppAnalyticsQuestionsQuestionIdAnswersRoute:
    AppAnalyticsQuestionsQuestionIdAnswersRoute,
}

const AppAnalyticsRouteWithChildren = AppAnalyticsRoute._addFileChildren(
  AppAnalyticsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsCampaignCommitteeRoute: typeof AppSettingsCampaignCommitteeRoute
  AppSettingsCampaignPreferencesRoute: typeof AppSettingsCampaignPreferencesRoute
  AppSettingsPlaybookRoute: typeof AppSettingsPlaybookRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsCampaignCommitteeRoute: AppSettingsCampaignCommitteeRoute,
  AppSettingsCampaignPreferencesRoute: AppSettingsCampaignPreferencesRoute,
  AppSettingsPlaybookRoute: AppSettingsPlaybookRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteRouteChildren {
  AppWorkOrdersRouteRoute: typeof AppWorkOrdersRouteRouteWithChildren
  AppAnalyticsRoute: typeof AppAnalyticsRouteWithChildren
  AppFieldOpsRoute: typeof AppFieldOpsRoute
  AppHomeRoute: typeof AppHomeRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppVoteGoalRoute: typeof AppVoteGoalRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppWorkOrdersRouteRoute: AppWorkOrdersRouteRouteWithChildren,
  AppAnalyticsRoute: AppAnalyticsRouteWithChildren,
  AppFieldOpsRoute: AppFieldOpsRoute,
  AppHomeRoute: AppHomeRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppVoteGoalRoute: AppVoteGoalRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AppRouteRoute: AppRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  CompleteRegistrationRoute: CompleteRegistrationRoute,
  DashboardRoute: DashboardRoute,
  EarlyRoute: EarlyRoute,
  EulaRoute: EulaRoute,
  GetStartedRoute: GetStartedRoute,
  LoginRoute: LoginRoute,
  OauthCallbackRoute: OauthCallbackRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SecurityRoute: SecurityRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
  WinNumberRoute: WinNumberRoute,
  DonateSlugRoute: DonateSlugRoute,
  EmbedSlugRoute: EmbedSlugRoute,
  ExpressCodeRoute: ExpressCodeRoute,
  ExpressSendRoute: ExpressSendRoute,
  LegalAcceptRoute: LegalAcceptRoute,
  SubscribeCompleteRoute: SubscribeCompleteRoute,
  TextStatusTokenRoute: TextStatusTokenRoute,
  VoterListTokenRoute: VoterListTokenRoute,
  SubscribeIndexRoute: SubscribeIndexRoute,
  SubsidiaryDonateSlugRoute: SubsidiaryDonateSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
